import type { BlOrderPaymentSchedule } from '@metycle/shared';
import { useQuery } from '@tanstack/react-query';

import { apiRequest } from '@/lib/api-client';

export type {
  PaymentScheduleTranche,
  PaymentScheduleSide,
  BlOrderPaymentSchedule,
} from '@metycle/shared';

export function paymentScheduleKey(blOrderId: string | undefined) {
  return ['bl-order-payment-schedule', blOrderId] as const;
}

// Read-only projection of the ticket's contract payment terms onto this BL
// (downpayment + BL tranches, with derived dates/amounts). Used by the
// sell-side Final Invoice to surface the contract schedule + settlement basis.
export function useBlOrderPaymentSchedule(blOrderId: string | undefined) {
  return useQuery<BlOrderPaymentSchedule>({
    queryKey: paymentScheduleKey(blOrderId),
    enabled: blOrderId !== undefined && blOrderId.length > 0,
    queryFn: () =>
      apiRequest<BlOrderPaymentSchedule>(
        `/bl-orders/${encodeURIComponent(blOrderId ?? '')}/payment-schedule`,
      ),
  });
}
